<button
  *ngIf="docStatus === documentStatus.Missing"
  type="button"
  id="btnUpload"
  class="btn btn-sm btn-outline-warning order-docs-button"
  (click)="uploadDocuments(order.id, order.cmrStatus, order.customerId)"
>
  <em class="fas fa-exclamation-triangle"></em>
  <span class="orders-button-txt mx-2">{{
    'SHARED.BUTTON-UPLOAD-DOC' | translate
  }}</span>
</button>
<button
  *ngIf="docStatus === documentStatus.Valid"
  type="button"
  id="btnUpload"
  class="btn btn-sm btn-outline-success order-docs-button"
  (click)="
    uploadDocuments(this.order.id, this.order.cmrStatus, this.order.customerId)
  "
>
  <em class="fas fa-check"></em>
  <span class="orders-button-txt mx-2">{{
    'SHARED.BUTTON-SEE-DOC' | translate
  }}</span>
</button>
<button
  *ngIf="docStatus === documentStatus.NotRequired"
  type="button"
  id="btnUpload"
  class="btn btn-sm btn-outline-info order-docs-button"
  (click)="uploadDocuments(order.id, order.cmrStatus, order.customerId)"
>
  <em class="fas fa-history"></em>
  <span class="orders-button-txt mx-2">{{
    'SHARED.BUTTON-SEE-DOC' | translate
  }}</span>
</button>
